/**
 * admin/ui — the admin portal's shared control + chrome primitives.
 * These match the /brand reference designs (Button family, Form field,
 * Banner, Empty state, List row) and replace the bespoke versions that
 * were re-implemented across the admin tree. All theme-driven (no hex);
 * pass `theme={PANE_THEMES.Admin}`.
 */
export { AdminButton } from "./AdminButton";
export type {
  AdminButtonProps,
  AdminButtonVariant,
  AdminButtonSize,
} from "./AdminButton";

export { AdminInput } from "./AdminInput";
export type { AdminInputProps } from "./AdminInput";

export { FilterChip } from "./FilterChip";
export type { FilterChipProps } from "./FilterChip";

export { AdminBanner, AdminToast } from "./AdminBanner";
export type { AdminBannerProps, AdminBannerTone } from "./AdminBanner";

export { AdminModal } from "./AdminModal";
export type { AdminModalProps } from "./AdminModal";

export { AdminAvatar, makeInitials } from "./AdminAvatar";

export { AdminCheckbox } from "./AdminCheckbox";

export {
  AdminPageHeader,
  AdminLoading,
  AdminEmpty,
  AdminError,
  AdminPageState,
} from "./AdminPageState";
export type {
  AdminPageHeaderProps,
  AdminEmptyProps,
  AdminPageStateProps,
} from "./AdminPageState";

// Cross-surface list/table row lives in the shared aspect catalog.
export { ListRow, ListRowGroup } from "../../aspects/ListRow";
export type { ListRowProps, ListRowGroupProps } from "../../aspects/ListRow";
